let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cArBx")).then(() => parcelRequire('4VB12'));